import { useEffect, useState } from "react";
import { encodeCuijPath } from "@tribunalea/shared";
import { PageHeader, useRouter } from "@tribunalea/ui";
import { useApi } from "../App.jsx";
import { WorkspaceDrafts } from "../components/WorkspaceDrafts.jsx";

function mergeExpedientes(active, archived) {
  const byCuij = new Map();
  active.forEach((expediente) => {
    byCuij.set(expediente.cuij, expediente);
  });
  archived.forEach((expediente) => {
    if (!byCuij.has(expediente.cuij)) {
      byCuij.set(expediente.cuij, { ...expediente, archived: true });
    }
  });
  return [...byCuij.values()].sort((left, right) =>
    String(left.caratula || left.cuij).localeCompare(
      String(right.caratula || right.cuij),
      "es",
      { sensitivity: "base" },
    ));
}

export function DraftsPage() {
  const api = useApi();
  const { path, navigate } = useRouter();
  const routeMatch = /^\/escritos(?:\/([^/]+))?\/?$/.exec(path);
  const selectedDocumentId = routeMatch?.[1]
    ? decodeURIComponent(routeMatch[1])
    : "";
  const [expedientes, setExpedientes] = useState([]);
  const [expedientesLoading, setExpedientesLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!selectedDocumentId) return undefined;
    let cancelled = false;
    api.getWorkspaceDocument(selectedDocumentId)
      .then((document) => {
        if (cancelled) return;
        const cuij = document.context?.id;
        if (!cuij) throw new Error("El escrito no tiene un expediente vinculado.");
        navigate(
          `/expedientes/${encodeCuijPath(cuij)}/escritos/${document.id}`,
          { replace: true },
        );
      })
      .catch((requestError) => {
        if (!cancelled) setError(requestError.message);
      });
    return () => {
      cancelled = true;
    };
  }, [api, navigate, selectedDocumentId]);

  useEffect(() => {
    let cancelled = false;
    setExpedientesLoading(true);
    setError("");
    Promise.all([
      api.listExpedientes(),
      api.listExpedientes({ archived: true }),
    ])
      .then(([active, archived]) => {
        if (!cancelled) setExpedientes(mergeExpedientes(active, archived));
      })
      .catch((requestError) => {
        if (!cancelled) setError(requestError.message);
      })
      .finally(() => {
        if (!cancelled) setExpedientesLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [api]);

  return (
    <div className="page drafts-page">
      <PageHeader
        className="drafts-page-heading"
        eyebrow="Praxis"
        title="Escritos y conversaciones"
        description="Buscá escritos y conversaciones vinculadas de todos tus expedientes."
      />
      {error && <div className="inline-error drafts-page-error">{error}</div>}
      <WorkspaceDrafts
        api={api}
        expedientes={expedientes}
        expedientesLoading={expedientesLoading}
        indexOnly
      />
    </div>
  );
}
